import { HtmlBlockValueResolver } from "@ihr-radioedit/inferno-core";
import { useHashAnchorLinks } from "@inferno/renderer-shared-ui";
import classnames from "classnames";
import { isLeft } from "fp-ts/lib/Either";
import { inject } from "mobx-react";
import { useEffect, useRef } from "react";
import { activateEmbeds, activateScripts } from "../lib/embed";
import { Container } from "../ui";
import { PageBlockInterface } from "./Block.component";
import styles from "./Html.module.scss";

export const Html = inject("store")(({ block, store }: PageBlockInterface) => {
  if (!store) {
    return null;
  }

  const contentRef = useRef<HTMLDivElement>(null);

  useHashAnchorLinks(contentRef, store);

  const value = HtmlBlockValueResolver.decode(block.value);
  const content = isLeft(value) ? undefined : value.right.content;

  useEffect(() => {
    const activation = new AbortController();
    if (contentRef.current) {
      activateScripts(contentRef.current, block.id, activation.signal);
    }
    return () => activation.abort();
  }, [content, block.id]);

  useEffect(() => {
    store.storeBlock(block);

    if (contentRef.current) {
      activateEmbeds(contentRef.current);
    }
  }, [block, store]);

  if (!content) {
    return null;
  }

  const htmlContainerClass = classnames(styles.componentHtml, {
    [styles.htmlContentStyle]: block.tags?.includes("display-hints/html-content-style"),
  });

  return (
    <Container data-test-type={block.type} className={htmlContainerClass}>
      <div data-html-block-content dangerouslySetInnerHTML={{ __html: content }} ref={contentRef} />
    </Container>
  );
});
